import Icon from '../components/Icon.vue'

Icon.register({
  'mortar-pestle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M501.5 60.9C518.8 43.7 514.1 14.7 492.3 3.8A35.7-35.7 0 0 1 454.9 7.1L251.1 160H402.5L501.5 60.9zM496 192H16C7.2 192 0 199.2 0 208V240C0 248.8 7.2 256 16 256H32C32 337 82.2 406.1 153.1 434.3 140.4 451.2 131.4 471.1 128.2 493 126.7 502.9 134.2 512 144.3 512H367.8C377.8 512 385.3 502.9 383.8 493 380.6 471.1 371.6 451.2 358.9 434.3 429.8 406.1 480 337 480 256H496C504.8 256 512 248.8 512 240V208C512 199.2 504.8 192 496 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mortar-pestle.js
// module id = UrnZ
// module chunks = 144